var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCerNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 22.475,
    viewBox: "0 0 20.8 22.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cer_none",
    transform: "translate(-1.2 -0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000009553883918564555090000005937718327473305257_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86798",
    "data-name": "\\uD328\\uC2A4 86798",
    d: "M20.6,4.2l.1.7h0a17.828,17.828,0,0,1,.1,2,21.184,21.184,0,0,1-.5,4.4,16.122,16.122,0,0,1-2.5,5.5,17.063,17.063,0,0,1-6.1,5.3l-.3.2-.3-.2A17.973,17.973,0,0,1,5,16.8a16.122,16.122,0,0,1-2.5-5.5,21.192,21.192,0,0,1-.4-4.4,17.828,17.828,0,0,1,.1-2h0l.1-.7c0-.2-.1-.5-.4-.5-.2-.1-.4.1-.5.3l-.1.7h0c0,.1-.1.9-.1,2.2a17.59,17.59,0,0,0,.6,4.6,17.828,17.828,0,0,0,2.6,5.8,17.931,17.931,0,0,0,6.4,5.6l.6.3a.3.3,0,0,0,.4,0l.6-.3a18.84,18.84,0,0,0,6.4-5.6,17.828,17.828,0,0,0,2.6-5.8A18.158,18.158,0,0,0,22,6.9c0-1.3-.1-2.1-.1-2.2h0L21.5,4c0-.2-.3-.4-.5-.4s-.4.3-.4.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86799",
    "data-name": "\\uD328\\uC2A4 86799",
    d: "M4.8,3.7l6.7-2,6.8,2.1a.446.446,0,0,0,.6-.3.446.446,0,0,0-.3-.6h0L11.6.8h-.3l-6.8,2a.486.486,0,0,0-.3.6A.419.419,0,0,0,4.8,3.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86800",
    "data-name": "\\uD328\\uC2A4 86800",
    d: "M1.5,4.3,11.1,23a.481.481,0,0,0,.6.2c.1,0,.1-.1.2-.2l5.9-10.9h0l3.7-7.8a.447.447,0,0,0-.8-.4h0L17,11.7,11.6,21.9,2.4,3.9a.663.663,0,0,0-.7-.2A.4.4,0,0,0,1.5,4.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86801",
    "data-name": "\\uD328\\uC2A4 86801",
    d: "M6.1,12.6H16.8a.4.4,0,0,0,.4-.5.43.43,0,0,0-.4-.4H6.1a.4.4,0,0,0-.4.5c-.1.2.1.4.4.4",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerNone);
export default __webpack_public_path__ + "static/media/cer_none.d37df6180732ec46336746414d67ed8d.svg";
export { ForwardRef as ReactComponent };